<template>
    <div id="login" @click="docClick($event)">
        <div id="loginBg" class="cle">
            <div class="fl login-lr cle">
                <div class="fr" id="loginLeftBg"></div>
            </div>
            <div class="fr login-lr">
                <div id="loginBox">
                    <div id="languageBox" class="cle">
                        <img class="fr" @click="langShow" style="margin-top:11px;cursor:default;" :src="stDt" alt="">
                        <div class="language lan-txt fr" @click="langShow" v-text="lanSelect"></div>
                        <ul v-show="lanShow" class="lanOptBox">
                            <li :class="lan===key?'lanChoice':''" @click="langChoice($event,key)" v-for="(item,key,index) in lanOpt" :key="index" v-text="lanOpt[key]"></li>
                            <img :src="stDt2" alt="">
                        </ul>
                        <select v-show="false" class="language" v-model="lan" v-on:change="lanChange($event)">
                            <option v-for="(item,key,index) in lanOpt" :key="index" :value="key" v-text="lanOpt[key]"></option>
                        </select>
                    </div>
                    <div id="loginMode" class="cle">
                        <div class="fl login-mode">
                            <div id="loginUser" :class="device?'nowMode fr':'fr'" :title="fromUser" @click="userShow" v-text="fromUser"></div>
                        </div>
                        <div class="fr login-mode">
                            <div id="loginDevice" :class="user?'nowMode fl':'fl'" :title="fromDevice" @click="deviceShow" v-text="fromDevice"></div>
                        </div>
                    </div>
                    <div id="loginModeBox">
                        <div id="loginUserBox" :class="{hide:user}">
                            <div class="cle">
                                <div class="fl login-icon">
                                    <img :src="userImg" alt="">
                                </div>
                                <input class="fl" v-if="phUPlaceholder" type="text" :placeholder="phUser" v-model="userName" v-on:blur="loginBlur($event,0)">
                                <input v-else class="placeholder fl" v-on:focus="preFocus($event,0)" type="text" :value="phUser">
                            </div>
                            <div class="cle">
                                <div class="fl login-icon">
                                    <img :src="pwdImg" alt="">
                                </div>
                                <input class="fl" v-if="phpwPlaceholder" maxlength="60" type="password" :placeholder="phpw" v-model="userPwd" v-on:blur="loginBlur($event,1)">
                                <input v-else class="placeholder fl" maxlength="60" v-on:focus="preFocus($event,1)" type="text" :value="phpw">
                            </div>
                        </div>
                        <div id="loginDeviceBox" :class="{hide:device}">
                            <div class="cle">
                                <div class="fl login-icon">
                                    <img :src="cloudImg" alt="">
                                </div>
                                <input v-if="cIdPlaceholder" type="text" @change="ie10Model($event,'cloudVal')" maxlength="12" :placeholder="cloudId" v-model="cloudVal" @keyup="limit" v-on:blur="loginBlur($event,2)">
                                <input v-else class="placeholder fl" v-on:focus="preFocus($event,2)" type="text" :value="cloudId">
                            </div>
                            <div class="cle">
                                <div class="fl login-icon">
                                    <img :src="userImg" alt="">
                                </div>
                                <input v-if="cIUPlaceholder" type="text" maxlength="60" :placeholder="cIUser" v-model="cloudUser" @keyup="devUesr" v-on:blur="loginBlur($event,3)">
                                <input v-else class="placeholder fl" v-on:focus="preFocus($event,3)" type="text" :value="cIUser">
                            </div>
                            <div class="cle">
                                <div class="fl login-icon">
                                    <img :src="pwdImg" alt="">
                                </div>
                                <input v-if="cIwPlaceholder" type="password" maxlength="60" :placeholder="cIpw" v-model="cloudPwd" @keyup="devPwd" v-on:blur="loginBlur($event,4)">
                                <input v-else class="placeholder fl" v-on:focus="preFocus($event,4)" type="text" :value="cIpw">
                            </div>
                        </div>
                        <div id="loginCheck" class="cle">
                            <span class="fl" id="loginGetPassword" @click="gPShow" v-text="getPwText"></span>
                            <span v-text="recordPw" class="fr"></span>
                            <input v-model="checked" class="fr" style="margin:0;padding:0;margin-top:5.5px;" type="checkbox" name="" id="">
                        </div>
                    </div>
                    <div id="loginBtn" :class="!user?'login-bottom-user':'login-bottom-device'">
                        <button type="button" class="fl" :class="{hide:user,addColor:addLC}" id="loginConfirm" @click="jump" @mousedown="loginDown" @mouseup="loginUp" @mouseleave="loginUp" :title="loginText" v-text="loginText"></button>
                        <button type="button" class="fl" :class="{hide:device,addColor:addLC}" id="cloudLoginConfirm" @click="jumpCloud" @mousedown="loginDown" @mouseup="loginUp" @mouseleave="loginUp" :title="loginText" v-text="loginText"></button>
                        <button class="fr" :class="{addColor:addRC}" id="loginRegister" type="button" @click="regShow" @mousedown="registerDown" @mouseup="registerUp" @mouseleave="registerUp" :title="registerText" v-text="registerText"></button>
                    </div>
                </div>
            </div>
            <div id="downBox">
                <ul id="loginBottom" class="cle">
                    <li class="fl cle" v-for="(item,index) in downAct" :key="index" @click="down(item.url,item.downloading)">
                        <img class="fl" :src="item.imgSrc" alt="">
                        <span class="fl" v-text="item.name"></span>
                    </li>
                </ul>
            </div>
        </div>
        <Register v-show="regBool" v-on:regWayShow="regClose" ref="regL"></Register>
        <GetPwd v-show="getPwdShow" v-on:getPwdOpen="getPwdOpen" v-on:changeSend="changeSend" ref="pwdL"></GetPwd>
        <ShareBomb v-show="sharebom" ref="share" v-on:close="shareClose"></ShareBomb>
        <div id="cloudObj" style="width:0;height:0;overflow:hidden;"></div>
        <loading v-show="loadings"></loading>
        <Dialog :lan="language" :dialog="dialogs" @close="dialogClose"></Dialog>
        <Vpload v-show="vPshow" :lan="language" @close="vPClose"></Vpload>
    </div>
</template>

<script>
import loading from './Loading'
import loginMes from '../assets/js/login'
import reg from './Register'
import GetPwd from './GetPwd'
import ShareBomb from './ShareBomb'
import Dialog from './Dialog'
import Vpload from './Vpload'
export default {
    name: 'Login',
    components:{
        Register:reg,
        GetPwd:GetPwd,
        ShareBomb:ShareBomb,
        loading:loading,
        Dialog:Dialog,
        Vpload:Vpload
    },
    data () {
        return {
            lan:this.baseData.lanDefault,
            lanSelect:'',
            lanOpt:this.listName,
            lanShow:false,
            user:false,
            device:true,
            addLC:false,
            addRC:false,
            stDt:'./static/img/selectDirection.png',
            stDt2:'./static/img/selectDirection2.png',
            userImg:'./static/img/user.png',
            pwdImg:'./static/img/pwd.png',
            cloudImg:'./static/img/cloud.png',
            userName:'',
            phUPlaceholder:true,
            userPwd:'',
            phpwPlaceholder:true,
            regBool:false,
            fromUser:'',
            fromDevice:'',
            phUser:'',
            phpw:'',
            cloudId:'',
            cIUser:'',
            cIpw:'',
            cloudVal:'',
            cIdPlaceholder:true,
            cloudUser:'',
            cIUPlaceholder:true,
            cloudPwd:'',
            cIwPlaceholder:true,
            isPlaceholder:false,
            recordPw:'',
            checked:false,
            loginText:'',
            registerText:'',
            getPwText:'',
            ocx:'',
            language:'',
            getPwdShow:false,
            sharebom:false,
            loadings:false,
            downList:[],
            wskD:null,
            wsS:true,
            wsT:false,
            pro:'http',
            isHs:0,
            IPPort:'',
            contP:'',
            dialogs:'',
            vPshow:false
        }
    },
    computed:{
        downAct:function(){
            var list=this.downList.filter(function(v,i){
                var ep=true;
                for(var key in v){
                    if(v[key]===''){
                        ep=false;
                    };
                };
                return ep;
            });
            return list;
        }
    },
    mounted:function(){
        this.downList=this.baseData.down;
        if(!('placeholder' in document.createElement('input'))){
            this.isPlaceholder=true;
        };
        var url=this.cloudName;
        // console.log(url)
        sessionStorage.setItem('token',false);
        var exsit =localStorage.getItem('checkbox');
        if (exsit+'' ==='null') {
            exsit = false;
        } else{
            exsit = true;
        };
        if (exsit) {
            if(localStorage.getItem("lan") in this.lanOpt){
                this.lan=localStorage.getItem("lan");
            };
            var name = unescape(localStorage.getItem("user"));
            if(name+''!=='null'){
                var pwd = unescape(localStorage.getItem("pwd"));
                this.userName=name;
                this.userPwd=pwd;
            };
            this.checked=true;
            var cloud=unescape(localStorage.getItem("cloudID"));
            if(cloud+''!=='null'){
                var cloudUser=unescape(localStorage.getItem("cloudIDUser"));
                var cloudPwd=unescape(localStorage.getItem("cloudPwd"));
                this.cloudVal=cloud;
                this.cloudUser=cloudUser;
                this.cloudPwd=cloudPwd;
            };
        };
        if(this.isPlaceholder){
            if(this.userName===''){
                this.phUPlaceholder=false;
            }else{
                this.phUPlaceholder=true;
            };
            if(this.userPwd===''){
                this.phpwPlaceholder=false;
            }else{
                this.phpwPlaceholder=true;
            };
            if(this.cloudVal===''){
                this.cIdPlaceholder=false;
            }else{
                this.cIdPlaceholder=true;
            };
            if(this.cloudUser===''){
                this.cIUPlaceholder=false;
            }else{
                this.cIUPlaceholder=true;
            };
            if(this.cloudPwd===''){
                this.cIwPlaceholder=false;
            }else{
                this.cIwPlaceholder=true;
            };
        };
        this.lanSelect=this.lanOpt[this.lan];
        var _that=this;
        document.onkeyup=function(event){
            var e=event||window.event;
            if ((e.keyCode || e.which) == 13) {
                if(this.lanShow===true){
                    this.lanShow=false;
                };
                if(this.regBool || this.getPwdShow ||this.sharebom)
                   return false;
                if(this.device){
                    this.jump();
                }else if(this.user){
                    this.jumpCloud();
                };
            };
        }.bind(this);
        this.lang();
        this.addObj();
        this.getUrl();
        var css=this.getCss('login');
        $('head').append('<style>'+css+'</style>');
        if(this.browserDetect() == 'IE')
        {
            setTimeout(function(){
                try {
                    var test=this.ocx.IGetSupportP2P()-0;
                } catch (error) {
                    if(this.$router.currentRoute.name==='Login'){
                        if(confirm(this.language['K149_plugIn'])){
                            window.open(this.baseData['Plug-in']);
                        };
                        this.vPshow=false;
                    };
                };
            }.bind(this), 3000);
        };
        if(this.browserDetect() !== 'IE')
        {
            var t=setInterval(function(){
                if(this.baseData.vSNt===-1||this.baseData.vSNt>=5){
                    clearTimeout(t);
                    this.wskD = new WebSocket("ws://127.0.0.1:"+this.baseData.vSPort);
                    this.wskD.onmessage = function(ev){
                        var msg = eval('(' + ev.data.replace(/[\r\n]/g,"").replace('version="1.0"','version=\\"1.0\\"').replace('encoding="UTF-8"','encoding=\\"UTF-8\\"') + ')');
                        var cm = Number(msg.cmd);
                        var res = msg.param;
                        switch (cm){
                            case 116:
                                if(this.isHs){
                                    this.cf_CloudidP2PHs(res[0]);
                                }else{
                                    this.cf_CloudidP2P(res[0]);
                                };
                                break;
                            case 133:
                                if(this.isHs){
                                    this.cf_CloudidP2PHsC(res[0]);
                                }else{
                                    this.cf_CloudidP2Ps(res[0]);
                                };
                                break;
                            default:
                        }
                    }.bind(this);
                    this.wskD.onopen = function() {
                        this.wsS = false;
                    }.bind(this);
                    this.wskD.onclose = function(event) {
                        if (this.wsS) {
                            this.wsS = false;
                            this.wsT = true;
                            this.vPshow=true;
                            // alert(this.language['K164_Connection']);
                        } else {
                            setTimeout(function() {
                                alert(this.language['K165_Disconnect']);
                            }.bind(this), 3000);
                        }
                    }.bind(this);
                };
            }.bind(this), 1000);
        }
    },
    methods:{
        langShow:function(){
            this.lanShow=true;
        },
        docClick:function(event){
            var name=event.target.tagName.toLowerCase();
            if(name==='img'&&$(event.target).parent().prop('id')==='languageBox'){
                return false;
            }else if(name==='div'&&$(event.target).parent().prop('id')==='languageBox'){
                return false;
            }else if(name==='li'&&$(event.target).parent().parent().prop('id')==='languageBox'){
                return false;
            }else{
                this.lanShow=false;
            };
        },
        langChoice:function(event,key){
            this.lan=key;
            this.lanSelect=this.lanOpt[key];
            this.lanShow=false;
            this.lanChange();
        },
        lanChange:function(_that){
            this.lang();
        },
        lang:function(){
            var lang='';
            if(this.lan in this.lanSave){
                lang=this.lanSave[this.lan];
            }else{
                lang=this.getLan(this.listFile,this.lan)[this.lan];
                if(lang===false){
                return false;
                };
                this.lanSave[this.lan]=lang;
            };
            this.language=lang;
            this.fromUser=lang['K000_User'];
            this.fromDevice=lang['K001_Device'];
            this.phUser=lang['K122_Account'];
            this.phpw=lang['K003_Password'];
            this.cloudId=lang['K004_CloudID'];
            this.cIUser=lang['K005_DeviceUserName'];
            this.cIpw=lang['K006_DevicePwd'];
            // this.phUser='';
            // this.phpw='';
            // this.cloudId='';
            // this.cIUser='';
            // this.cIpw='';
            this.recordPw=lang['K007_KeepPwd'];
            this.loginText=lang['K008_Login'];
            this.registerText=lang['K009_Register'];
            this.getPwText=lang['K020_FindPwd'];
            this.$refs.regL.language(this.lan);
            this.$refs.pwdL.lang(this.lan);
            this.$refs.share.lang(this.lan);
        },
        userShow:function(){
            this.user=false;
            this.device=true;
        },
        deviceShow:function(){
            this.user=true;
            this.device=false;
        },
        preFocus:function(_that,num){
            if(num===0){
                this.phUPlaceholder=true;
            }else if(num===1){
                this.phpwPlaceholder=true;
            }else if(num===2){
                this.cIdPlaceholder=true;
            }else if(num===3){
                this.cIUPlaceholder=true;
            }else if(num===4){
                this.cIwPlaceholder=true;
            };
        },
        loginBlur:function(_that,num){
            if(this.isPlaceholder){
                if(this.userName===''&&num===0){
                    this.phUPlaceholder=false;
                };
                if(this.userPwd===''&&num===1){
                    this.phpwPlaceholder=false;
                };
                if(this.cloudVal===''&&num===2){
                    this.cIdPlaceholder=false;
                };
                if(this.cloudVal!==''&&num===2){
                    this.limit();
                };
                if(this.cloudUser===''&&num===3){
                    this.cIUPlaceholder=false;
                };
                if(this.cloudPwd===''&&num===4){
                    this.cIwPlaceholder=false;
                };
            };
        },
        limit:function(){
            var id=(/[a-zA-Z0-9]+/g).exec(this.cloudVal);
            if($.type(id)==='null'){
                id='';
            }else if($.type(id)==='array'){
                id=id[0]==='undefined'?'':id[0];
            };
            this.cloudVal=id===null?'':id;
        },
        devUesr:function(){
            var id=this.reg.devUser.limit.exec(this.cloudUser);
            if($.type(id)==='null'){
                id='';
            }else if($.type(id)==='array'){
                id=id[0]==='undefined'?'':id[0];
            };
            this.cloudUser=id===null?'':id;
        },
        devPwd:function(){
            var id=this.reg.devPwd.limit.exec(this.cloudPwd);
            if($.type(id)==='null'){
                id='';
            }else if($.type(id)==='array'){
                id=id[0]==='undefined'?'':id[0];
            };
            this.cloudPwd=id===null?'':id;
        },
        loginDown:function(){
            this.addLC=true;
        },
        loginUp:function(){
            this.addLC=false;
        },
        registerDown:function(){
            this.addRC=true;
        },
        registerUp:function(){
            this.addRC=false;
        },
        jump:function(){
            var url=this.cloudName;
            if(this.userName===''){
                alert(this.language['K144_UserEmpty']);
                return false;
            };
            if(this.userPwd===''){
                alert(this.language['K145_PwdEmpty']);
                return false;
            };
            var xml=loginMes.login({
                oem:this.baseData.oem,
                userName:this.userName,
                userPwd:this.hashEncryption(this.userPwd)
            });
            var data=this.ajaxSet({
                ip:url,
                type:'auth/user',
                xml:xml
            });
            var msg=data.data;
            this.jumpResult(msg);
        },
        jumpResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                localStorage.setItem('userName',this.userName);
                var sessionId=$(data).find('session').find('id').text();
                localStorage.setItem('sessionId',sessionId);
                localStorage.setItem('lan',this.lan);
                sessionStorage.setItem('token',true);
                localStorage.setItem('user',unescape(this.userName));
                localStorage.setItem('pwd',unescape(this.userPwd));
                if(this.checked){
                    localStorage.setItem('checkbox',this.checked);
                }else{
                    localStorage.removeItem('checkbox',this.checked);
                };
                //记住登录
                // localStorage.setItem('record',true);
                this.$router.push({
                    name:'Cloud',
                    params:{
                        user:this.userName,
                        sessionId:sessionId
                    }
                });
            }else if(result==='100101000'){
                this.setPosID($(data).find('redirect-region-id').text());
                this.jump();
            }else{
                var key = this.promptInfo(result);
                alert(this.language[key] == undefined ? key : this.language[key]);
            };
        },
        jumpCloud:function(){
            if(this.cloudVal===''){
                alert(this.language['K146_CloudEmpty']);
                return false;
            };
            if(this.cloudUser===''){
                alert(this.language['K144_UserEmpty']);
                return false;
            };
            var num=this.reg.devPwd.num;
            var leng=this.StrByteCountFun(this.cloudPwd);
            if(leng>num[1]){
                alert(this.language['K208_Limit']);
                return false;
            };
            
            this.loadings=true;
            if(this.browserDetect() !== 'IE'){
                if(this.wskD.readyState===1){
                    this.pro='http://';
                    var r=/^um/g;
                    if(r.test(this.cloudVal)){
                        this.isHs=1;
                        this.wskD.send(this.jsonStr(116,[this.cloudVal,2,'0']));//非IE浏览器端口穿透华视云
                    }else{
                        this.isHs=0;
                        this.wskD.send(this.jsonStr(116,[this.cloudVal,2,'1']));//非IE浏览器端口穿透
                    };
                }else{
                    this.loadings=false;
                    if(this.wsT)
                        alert(this.language['K164_Connection']);
                    else
                        alert(this.language['K165_Disconnect']);
                };
                return false;
            };
            setTimeout(function(){
                var ocx=this.ocx;
                try {
                    var test=ocx.IGetSupportP2P()-0;
                    if(test===0){
                        this.vPshow=false;
                        if(confirm(this.language['K160_NoSupport'])){
                            this.loadings=false;
                            window.open(this.baseData['Plug-in']);
                        }else{
                            this.loadings=false;
                        };
                        return false;
                    };
                } catch (error) {
                    this.vPshow=false;
                    if(confirm(this.language['K149_plugIn'])){
                        this.loadings=false;
                        window.open(this.baseData['Plug-in']);
                    }else{
                        this.loadings=false;
                    };
                    return false;
                };
                var r=/^um/g;
                if(r.test(this.cloudVal)){
                    this.pro='http://';
                    this.isHs=1;
                    var po=ocx.ICloudAddMapPort(this.cloudVal, 2, 0)-0;
                    if (po <= 0){
                        this.loadings=false;
                        alert(this.language['K174_Fail']);
                        return false;
                    };
                    var content = '<?xml version="1.0" encoding="utf-8"?>' +
                        '<envelope>' +
                        '<header>' +
                        '<security>username</security>' +
                        '<username>' + this.cloudUser + '</username>' +
                        '<password>' + this.cloudPwd + '</password>' +
                        '</header>' +
                        '<body>' +
                        '<command>get.system.login</command>' +
                        '<content></content>' +
                        '</body>' +
                        '</envelope>';
                    var states = ocx.IGetCGI("http://127.0.0.1:" + po + "/tdkcgi", content);
                    if (states === 'error'){
                        var status = ocx.IGetCGI("https://127.0.0.1:" + po + "/tdkcgi", content);
                        if(status === 'error'){
                            var pos=ocx.ICloudAddMapPort(this.cloudVal, 1, 0)-0;
                            if(pos>0){
                                window.open('./webClient.html?'+this.cloudVal+'&'+this.cloudUser+'&'+this.cloudPwd+'&'+this.lan);
                                this.loadings=false;
                                return false;
                            };
                            this.loadings=false;
                            alert(this.language['K174_Fail']);
                            return false;
                        }else {
                            this.pro = 'https://';
                        };
                    };
                    this.loadings=false;
                    var deviceUserName=this.cloudUser;
                    var baseFun=this.base64;
                    var base=new baseFun();
                    var user=base.encode(this.cloudUser);
                    var pwdHE=this.cloudPwd;
                    var cloudPwd=base.encode(pwdHE);
                    var url = this.pro+"127.0.0.1:" + po + "/main.html" + "?" + po + "&" + this.cloudVal +
                        "&" +user+ "&" + cloudPwd+ "&" + this.lan;
                    if(this.checked){
                        localStorage.setItem('cloudID',escape(this.cloudVal));
                        localStorage.setItem('cloudIDUser',escape(this.cloudUser));
                        localStorage.setItem('cloudPwd',escape(this.cloudPwd));
                        localStorage.setItem('checkbox',this.checked);
                    }else{
                        localStorage.removeItem('cloudID',escape(this.cloudVal));
                        localStorage.removeItem('cloudIDUser',escape(this.cloudUser));
                        localStorage.removeItem('cloudPwd',escape(this.cloudPwd));
                        localStorage.removeItem('checkbox',this.checked);
                    };
                    window.location.href=url;
                    return false;
                };
                if(ocx.IGetSupportP2P()-0){
                    this.loadings=false;
                    this.pro='http://';
                    this.isHs=0;
                    var port=ocx.ICloudAddMapPortEx(this.cloudVal,2);
                    if(port-0===0){
                        port=ocx.ICloudAddMapPortEx(this.cloudVal,1);
                        this.pro='https://';
                    }else{
                        var content = '<?xml version="1.0" encoding="utf-8"?>' +
                            '<envelope>' +
                            '<header>' +
                            '<security>username</security>' +
                            '<username>' + this.cloudUser + '</username>' +
                            '<password>' + this.cloudPwd + '</password>' +
                            '</header>' +
                            '<body>' +
                            '<command>get.system.login</command>' +
                            '<content></content>' +
                            '</body>' +
                            '</envelope>';
                        var states = ocx.IGetCGI("http://127.0.0.1:" + port + "/tdkcgi", content);
                        if (states === 'error'){
                            port=ocx.ICloudAddMapPortEx(this.cloudVal,1);
                            this.pro='https://';
                        };
                    };
                    if(port-0===0){
                        alert(this.language['K174_Fail']);
                    }else{
                        var deviceUserName='adminapp';
                        var baseFun=this.base64;
                        var base=new baseFun();
                        var user=base.encode(this.cloudUser);
                        var pwdHE=this.cloudPwd;
                        var cloudPwd=base.encode(pwdHE);
                        var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + this.cloudVal +
                            "&" +user+ "&" + cloudPwd+ "&" + this.lan;
                        if(this.checked){
                            localStorage.setItem('cloudID',escape(this.cloudVal));
                            localStorage.setItem('cloudIDUser',escape(this.cloudUser));
                            localStorage.setItem('cloudPwd',escape(this.cloudPwd));
                            localStorage.setItem('checkbox',this.checked);
                        }else{
                            localStorage.removeItem('cloudID',escape(this.cloudVal));
                            localStorage.removeItem('cloudIDUser',escape(this.cloudUser));
                            localStorage.removeItem('cloudPwd',escape(this.cloudPwd));
                            localStorage.removeItem('checkbox',this.checked);
                        };
                        window.location.href=url;
                    };
                    
                };
            }.bind(this),3000);
        },
        cf_CloudidP2P:function(port){
            if(port-0===0&&this.pro==='http://'){
                this.wskD.send(this.jsonStr(116,[this.cloudVal,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            }else if(port-0!==0&&this.pro==='http://'){
                var content = '<?xml version="1.0" encoding="utf-8"?>' +
                    '<envelope>' +
                    '<header>' +
                    '<security>username</security>' +
                    '<username>' + this.cloudUser + '</username>' +
                    '<password>' + this.cloudPwd + '</password>' +
                    '</header>' +
                    '<body>' +
                    '<command>get.system.login</command>' +
                    '<content></content>' +
                    '</body>' +
                    '</envelope>';
                this.IPPort=port-0;
                this.contP=content;
                this.wskD.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
                return false;
            };
            this.cf_CloudidP2PJump(port);
        },
        cf_CloudidP2Ps:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.wskD.send(this.jsonStr(116,[this.cloudVal,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            };
            this.cf_CloudidP2PJump(this.IPPort);
        },
        cf_CloudidP2PJump:function(port){
            this.loadings=false;
            if(port-0===0){
                alert(this.language['K174_Fail']);
            }else{
                var deviceUserName='adminapp';
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(this.cloudUser);
                var pwdHE=this.cloudPwd;
                var cloudPwd=base.encode(pwdHE);
                var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + this.cloudVal +
                    "&" +user+ "&" + cloudPwd+ "&" + this.lan;
                if(this.checked){
                    localStorage.setItem('cloudID',escape(this.cloudVal));
                    localStorage.setItem('cloudIDUser',escape(this.cloudUser));
                    localStorage.setItem('cloudPwd',escape(this.cloudPwd));
                    localStorage.setItem('checkbox',this.checked);
                }else{
                    localStorage.removeItem('cloudID',escape(this.cloudVal));
                    localStorage.removeItem('cloudIDUser',escape(this.cloudUser));
                    localStorage.removeItem('cloudPwd',escape(this.cloudPwd));
                    localStorage.removeItem('checkbox',this.checked);
                };
                window.location.href=url;
            };
        },
        cf_CloudidP2PHs:function(port){
            if (port-0 <= 0){
                alert(this.language['K174_Fail']);
                this.loadings=false;
                return false;
            };
            var content = '<?xml version="1.0" encoding="utf-8"?>' +
                '<envelope>' +
                '<header>' +
                '<security>username</security>' +
                '<username>' + this.cloudUser + '</username>' +
                '<password>' + this.cloudPwd + '</password>' +
                '</header>' +
                '<body>' +
                '<command>get.system.login</command>' +
                '<content></content>' +
                '</body>' +
                '</envelope>';
            this.IPPort=port-0;
            this.contP=content;
            this.wskD.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
        },
        cf_CloudidP2PHsC:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.pro='https://';
                this.wskD.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + this.IPPort + "/tdkcgi",this.contP]));
            }else if(status === 'error'&&this.pro==='https://'){
                this.loadings=false;
            }else{
                this.loadings=false;
                var deviceUserName=this.cloudUser;
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(this.cloudUser);
                var pwdHE=this.cloudPwd;
                var cloudPwd=base.encode(pwdHE);
                var url = this.pro+"127.0.0.1:" + this.IPPort + "/main.html" + "?" + this.IPPort + "&" + this.cloudVal +
                    "&" +user+ "&" + cloudPwd+ "&" + this.lan;
                if(this.checked){
                    localStorage.setItem('cloudID',escape(this.cloudVal));
                    localStorage.setItem('cloudIDUser',escape(this.cloudUser));
                    localStorage.setItem('cloudPwd',escape(this.cloudPwd));
                    localStorage.setItem('checkbox',this.checked);
                }else{
                    localStorage.removeItem('cloudID',escape(this.cloudVal));
                    localStorage.removeItem('cloudIDUser',escape(this.cloudUser));
                    localStorage.removeItem('cloudPwd',escape(this.cloudPwd));
                    localStorage.removeItem('checkbox',this.checked);
                };
                window.location.href=url;
            };
        },
        regShow:function(){
            this.regBool = true;
        },
        regClose:function(data){
            this.regBool = data;
        },
        getUrl:function(ip,server,async,ips){
            this.setPosID(this.posID);
        },
        gPShow:function(){
            this.getPwdShow=true;
        },
        getPwdOpen:function(data){
            this.getPwdShow=data;
        },
        changeSend:function(data){
            this.setPosID(data.id);
            if(data.type==='linkPhone'){
                this.$refs.pwdL.pwdPhone();
            }else if(data.type==='linkEmile'){
                this.$refs.pwdL.pwdEmile();
            }else if(data.type==='codeEmile'){
                this.$refs.pwdL.pwdEmile();
            }else if(data.type==='Phonecode'){
                this.$refs.pwdL.getCodeNum();
            }else if(data.type==='Emilecode'){
                this.$refs.pwdL.getCodeNums();
            };
        },
        down:function(url,downloading){
        // console.log(url)
            if(url===''){
                return false;
            };
            if(!downloading){
                this.$refs.share.setQRCode(url);
                this.sharebom=true;
                return false;
            };
            window.open(url);
            // location.href=url;
        },
        shareClose:function(){
            this.sharebom=false;
        },
        dialogClose:function(){
            
        },
        vPClose:function(){
            this.vPshow=false;
        },
        addObj:function(){
            var system=this.detectOS();
            if (system === "win") {
                var obj="<object name='ocx' id='ocx' width='0' height='0' classid='CLSID:E0DA039D-992F-4187-A105-C699A71F5F06'></object>";;
                $('#cloudObj').append(obj);
            } else if (system === "Mac") {
                var obj="<embed width='0' height='0' type='text/x-vplugin' name='ocx' id='ocx'>";;
                $('#cloudObj').append(obj);
            };
            this.ocx=$('#ocx')[0];
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #login{
        width:100%;
        min-width:1440px;
        height:100%;
        min-height:800px;
        background:url('../assets/images/loginBg.png') no-repeat;
        background-size:cover;
        position: relative;
    }
    #loginBg{
        width:100%;
        height:500px;
        position: absolute;
        top:50%;
        margin-top:-250px;
    }
    .login-lr{
        width:42%;
        height:100%;
    }
    #loginLeftBg{
        width:500px;
        height:100%;
        background:url('../assets/images/loginBgP.png') no-repeat;
    }
    #loginBox{
        width:400px;
        height:360px;
        background-color: #11366A;
        box-sizing: border-box;
        margin-top:70px;
        padding:0 50px;
        position: relative;
        overflow: hidden;
    }
    #languageBox{
        width:100%;
        height:24px;
        margin-top:10px;
        position:relative;
    }
    .language{
        width:120px;
        height:100%;
        box-sizing: border-box;
    }
    .lan-txt{
        width:90px;
        padding-left: 10px;
        line-height: 24px;
        color: #6ad4f8;
        font-size:14px;
        cursor:default;
    }
    .lanOptBox{
        width:98px;
        height:auto;
        border:1px solid #6AD4F8;
        box-sizing: border-box;
        position:absolute;
        top:0px;
        right:0;
    }
    .lanOptBox li{
        width:100%;
        height:24px;
        padding-left: 10px;
        box-sizing: border-box;
        line-height: 24px;
        font-size:14px;
        color:#fff;
        background:#0C2D57;
        cursor: default;
    }
    .lanOptBox li:hover{
        color:#6AD4F8;
    }
    .lanOptBox .lanChoice{
        color:#6AD4F8;
    }
    .lanOptBox img{
        position:absolute;
        top:9px;
        right:5px;
    }
    #loginMode{
        width:100%;
        height: 34px;
        margin-top:10px;
    }
    .login-mode{
        width:44%;
        height:100%;
    }
    #loginMode .nowMode::after{
        width:40px;
        height:2px;
        display: block;
        content:'';
        margin:0 auto;
        border-bottom:2px solid #6AD4F8;
    }
    #loginUser{
        text-align: right;
    }
    #loginDevice{
        text-align: left;
    }
    #loginUser,#loginDevice{
        width:auto;
        height: 100%;
        max-width: 100%;
        font-size:20px;
        color:#fff;
        line-height: 30px;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor:default;
    }
    #loginModeBox{
        width:100%;
        margin-top:10px;
    }
    #loginUserBox{
        width:100%;
        height:100px;
        box-sizing: border-box;
    }
    .login-icon{
        width:40px;
        height:100%;
        text-align: center;
    }
    .login-icon img{
        margin-top:9px;
    }
    #loginUserBox input{
        color:#bbc2d2;
        background-color:#1b4180;
    }
    #loginUserBox>div+div{
        margin-top:20px;
    }
    #loginUserBox>div{
        width:100%;
        height:40px;
        background-color:#1b4180;
        box-sizing: border-box;
        border-radius:6px;
    }
    #loginUserBox div input{
        width:calc(100% - 44px);
        height:100%;
        border:none;
        outline: none;
        box-sizing: border-box;
    }
    #loginDeviceBox{
        width:100%;
        height:160px;
        box-sizing: border-box;
    }
    #loginDeviceBox input{
        color:#bbc2d2;
        background-color:#1b4180;
    }
    #loginDeviceBox>div+div{
        margin-top:20px;
    }
    #loginDeviceBox>div{
        width:100%;
        height:40px;
        background-color:#1b4180;
        box-sizing: border-box;
        border-radius:6px;
    }
    #loginDeviceBox div input{
        width:calc(100% - 44px);
        height:100%;
        border:none;
        outline: none;
        box-sizing: border-box;
    }
    .placeholder{
        color:#6D6D6D;
    }
    #loginCheck{
        width:100%;
        height:24px;
        color:#fff;
        margin-top:10px;
    }
    #loginCheck span{
        font-size:12px;
        line-height:24px;
    }
    #loginCheck span+span{
        margin-left:10px;
    }
    .login-bottom-user{
        margin-top:70px;
    }
    .login-bottom-device{
        margin-top:10px;
    }
    #loginBtn{
        width:100%;
        height:40px;
    }
    #loginBtn button{
        width:130px;
        height:100%;
        color:#EFF3F8;
        font-size:14px;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor:pointer;
    }
    #loginBtn button:hover{
        color:#fff;
        background-color:#0193FF;
    }
    #downBox{
        width:100%;
        height:30px;
        position: absolute;
        left:0;
        bottom:-24px;
        text-align: center;
    }
    #loginBottom{
        height:100%;
        display: inline-block;
    }
    #loginBottom li{
        /* width:100px; */
        width:140px;
        height:100%;
        color:#285876;
        font-size:14px;
        font-weight: bold;
        line-height:30px;
        cursor: pointer;
    }
    #loginBottom li span{
        margin-left:15px;
    }
    #loginBottom li+li{
        margin-left:30px;
    }
    #loginGetPassword{
        cursor:pointer
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue